import { P2GText } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GBox } from '@parcel2go/core-ui';
import { QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';
import { useTaxName } from '@parcel2go/npm-p2g-app';
import { QuoteOptionLabel } from './QuoteOptionLabel';

interface props {
  estimatedValue: number;
  isSelected: boolean;
  onSelect: () => void;
  option: QuoteOptionApiModel;
  currencyCode: string;
}

export function QuoteOption(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const taxName = useTaxName();

  if (props.option.Unavailable) {
    return (
      <P2GGrid container alignItems="center" wrap="nowrap" gap={1}>
        <P2GGrid item flexGrow={1}>
          <P2GText variant="body2" colour="primary">
            <Trans t={t} i18nKey="QUOTE_OPTION_UNAVAILABLE_MESSAGE" defaults="Unavailable<br />on this service" />
          </P2GText>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <div style={{ opacity: 0.5 }}>
            <P2GCheckBoxLegacy
              labelPlacement="start"
              label={
                <P2GText variant="body2" colour="textSecondary">
                  <QuoteOptionLabel
                    option={props.option}
                    estimatedValue={props.estimatedValue}
                    currencyCode={props.currencyCode}
                  />
                </P2GText>
              }
              checked={false}
              id="Selected"
              onChange={() => {}}
              variant="primary"
              error={false}
            />
          </div>
        </P2GGrid>
      </P2GGrid>
    );
  }

  return (
    <P2GBox onClick={props.onSelect}>
      <P2GGrid container alignItems="center" wrap="nowrap" gap={1}>
        <P2GGrid item flexGrow={1}>
          {props.option.VatRate > 0 ? (
            <>
              <div>
                <P2GText component="span" variant="h4" value={props.option.TotalPriceExVat}>
                  {toDisplayCurrency(props.currencyCode, props.option.TotalPriceExVat)}
                </P2GText>{' '}
                <P2GText component="span" variant="body2">
                  <span style={{ fontSize: '10px' }}>
                    {t(`EXCLUDING_TAX`, { defaultValue: `exc {{taxName}}`, taxName: taxName })}
                  </span>
                </P2GText>
              </div>
              <div>
                <P2GText component="span" variant="body2" value={props.option.TotalPrice}>
                  {toDisplayCurrency(props.currencyCode, props.option.TotalPrice)}
                </P2GText>{' '}
                <P2GText component="span" variant="body2">
                  <span style={{ fontSize: '10px' }}>
                    {t(`INCLUDING_TAX`, { defaultValue: `inc {{taxName}}`, taxName: taxName })}
                  </span>
                </P2GText>
              </div>
            </>
          ) : (
            <div>
              <P2GText component="span" variant="h4" value={props.option.TotalPrice}>
                {toDisplayCurrency(props.currencyCode, props.option.TotalPrice)}
              </P2GText>{' '}
              <P2GText component="span" variant="body2">
                <span style={{ fontSize: '10px' }}>
                  {t(`INCLUDING_TAX`, { defaultValue: `inc {{taxName}}`, taxName: taxName })}
                </span>
              </P2GText>
            </div>
          )}
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <P2GCheckBoxLegacy
            labelPlacement="start"
            variant="primary"
            error={false}
            label={
              <P2GText variant="body2" colour="textSecondary">
                <QuoteOptionLabel
                  option={props.option}
                  estimatedValue={props.estimatedValue}
                  currencyCode={props.currencyCode}
                />
              </P2GText>
            }
            checked={props.isSelected}
            id="Selected"
            onChange={() => {}}
          />
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  );
}
